module.exports = __webpack_public_path__ + "img/PPMP20.e8ff446b.png";